import { Component, OnInit } from '@angular/core';
import { AlertVoiceService } from './alert-voice.service';
import { MessageService } from '@kanzi-apes/kanzi-prime-ui';
import { TranslateService, _ } from '@ngx-translate/core';

/**
 * @author Hugo Andrés Escobar Ciceri
 * @version 7.0.0
 *
 * Alert Component to show messages on the top the main section.
 */
@Component({
    selector: 'kanzi-apes-alert-voice',
    templateUrl: './alert-voice.component.html',
    styleUrls: ['./alert-voice.component.scss'],
    providers: [MessageService],
    standalone: false
})
export class AlertVoiceComponent implements OnInit {
  /**
   *
   * @param alertService {AlertVoiceService} Service to send and receive messages.
   */
  constructor(
    private alertService: AlertVoiceService,
    private primeMsgService: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.alertService
      .getMessage()
      .subscribe((message: { type: string; title: string; text: string }) => {
        if (message) {
          this.primeMsgService.clear('alertVoice');

          // Translate title and text before adding to message service
          this.translate
            .get(_(message.title))
            .subscribe((translatedTitle: string) => {
              this.translate
                .get(_(message.text))
                .subscribe((translatedText: string) => {
                  this.primeMsgService.add({
                    key: 'alertVoice',
                    severity: message.type,
                    summary: translatedTitle,
                    detail: translatedText,
                    sticky: false,
                  });
                });
            });
        }
      });
  }
}
